import { render, staticRenderFns } from "./forum.vue?vue&type=template&id=65b24f12&scoped=true"
import script from "./forum.vue?vue&type=script&lang=js"
export * from "./forum.vue?vue&type=script&lang=js"
import style0 from "./forum.vue?vue&type=style&index=0&id=65b24f12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b24f12",
  null
  
)

export default component.exports